<template>
  <!-- Modal -->
  <div class="modal fade" id="editarModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar regla de cobro</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="edit_instituciones">Instituciones:</label>
                <select class="form-control" id="edit_instituciones" v-model="reglaCobro.institucion_id" @change="changeInstitucion" required>
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="i in instituciones" :key="i.id" :value="i.id">{{ i.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="edit_ciclo_escolar">Ciclo escolar</label>
                <select class="form-control" id="edit_ciclo_escolar" v-model="reglaCobro.ciclo_escolar_id" required>
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="ce in ciclos_escolares" :key="ce.id" :value="ce.id">{{ ce.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" name="aplica" type="radio" id="editar_r_programa" value="programa" @change="aplicaChange" v-model="aplica">
                  <label class="form-check-label" for="editar_r_programa">Programa</label>
                </div>

                <select class="form-control" id="editar_programa" v-model="reglaCobro.programa_id" :disabled="aplica != 'programa'">
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="p in programas" :key="p.id" :value="p.id">{{ p.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" name="aplica" type="radio" id="editar_r_nacademico" value="nacademico" @change="aplicaChange" v-model="aplica">
                  <label class="form-check-label" for="editar_r_nacademico">Nivel Académico</label>
                </div>

                <select class="form-control" id="editar_nivel_academico" v-model="reglaCobro.nivel_academico_id" :disabled="aplica != 'nacademico'">
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="n in niveles_academicos" :key="n.id" :value="n.id">{{ n.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_es_servicio">Es servicio</label>
                <select class="form-control" id="editar_es_servicio" v-model="reglaCobro.es_servicio">
                  <option value="si">Si</option>
                  <option value="no">No</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group" v-if="reglaCobro.es_servicio == 'si'">
                <label for="editar_tipo_servicio">Tipo de servicio</label>
                <select class="form-control" id="editar_tipo_servicio" v-model="reglaCobro.tipo_servicio">
                  <option value="requerido">Obligatorio</option>
                  <option value="opcional">Opcional</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_tipo_alumno">Tipo de alumno</label>
                <select class="form-control" id="editar_tipo_alumno" v-model="reglaCobro.tipo_alumno" required>
                  <option v-for="t in tipos_de_alumno" :key="t.id" :value="t.id">{{ t.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_fecha_vigencia">Fechas de vigencia</label>
                <select class="form-control" id="editar_fecha_vigencia" v-model="reglaCobro.fecha_vigencia_id">
                  <option v-for="cd in fechas_de_vigencia" :key="cd.id" :value="cd.id">{{ cd.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_concepto">Concepto</label>
                <select class="form-control" id="editar_concepto" v-model="reglaCobro.codigo_detalle_id">
                  <option v-for="c in conceptos" :key="c.id" :value="c.id">{{ c.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_tipo_cobro">Tipo de cobro</label>
                <select class="form-control" id="editar_tipo_cobro" v-model="reglaCobro.tipo_cobro">
                  <option value="porcreditos">Por créditos</option>
                  <option value="montofijo">Monto fijo</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_monto">Monto</label>
                <input type="number" class="form-control" id="editar_monto" v-model="reglaCobro.monto" />
              </div>
            </div>

            <div class="col-6">
              <div class="row" v-if="reglaCobro.tipo_cobro == 'porcreditos'">
                <div class="col-6">
                  <div class="form-group">
                    <label for="editar_min_creditos">Min. Créditos</label>
                    <input type="email" class="form-control" id="editar_min_creditos" v-model="reglaCobro.min_creditos" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="editar_max_creditos">Max. Créditos</label>
                    <input type="email" class="form-control" id="editar_max_creditos" v-model="reglaCobro.max_creditos" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_dias_tolerancia">Días de tolerancia para la beca</label>
                <input type="number" class="form-control" id="editar_dias_tolerancia" v-model="reglaCobro.dias_tolerancia" />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="save">Guardar y cerrar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Axios from 'axios';

export default {
  props: [ 'reglaCobroId' ],
  data() {
    return {
      instituciones: [],
      ciclos_escolares: [],
      programas: [],
      niveles_academicos: [],
      conceptos: [],
      tipos_de_alumno: [],
      fechas_de_vigencia: [],
      aplica: '',
      reglaCobro: {
        atributo_id: null,
        ciclo_escolar_id: '',
        codigo_detalle_id: 0,
        created_at: "",
        dias_tolerancia: 0,
        es_servicio:"",
        fecha_vigencia_id: 0,
        id: 0,
        institucion_id: '',
        max_creditos: null,
        min_creditos: null,
        monto: 0,
        nivel_academico_id: null,
        programa_id: 0,
        tipo_alumno: "",
        tipo_cobro: "",
        tipo_servicio: "",
        updated_at: ""
      }
    }
  },
  async created() {
    this.instituciones = await Axios.get('/instituciones/usuario').then(resp => resp.data);
    this.conceptos = await Axios.get('/codigos-de-detalle/listado?tipo=cargo').then(resp => resp.data);
    this.tipos_de_alumno = await Axios.get('/reglas-de-cobro/tipos-de-alumnos/listado').then(resp => resp.data);

    $('#editarModal').on('show.bs.modal', async () => {
      await this.load();
    });
  },
  computed: {
    multiwatch() {
      return `${this.reglaCobro.institucion_id}|${this.reglaCobro.ciclo_escolar_id}`;
    }
  },
  methods: {
    async changeInstitucion() {
      this.ciclos_escolares = await Axios.get(`/ciclos-escolares/ciclosPorInstitucion/${this.reglaCobro.institucion_id}`).then(resp => resp.data);
      this.programas = await Axios.get(`/programas/institucion/${this.reglaCobro.institucion_id}`).then(resp => resp.data);
      this.niveles_academicos = await Axios.get(`/niveles-academicos/filtrar?institucion_id=${this.reglaCobro.institucion_id}`).then(resp => resp.data);
    },
    aplicaChange() {
      if (this.aplica == 'programa') {
        this.reglaCobro.nivel_academico_id = '';
      } else {
        this.reglaCobro.programa_id = '';
      }
    },
    async save() {
      await Axios.post('/reglas-de-cobro/actualizar', this.reglaCobro).then(resp => {
        toastr["success"]('Registro Actualizado');
        $('#editarModal').modal('hide');
        document.getElementById('r_search').click();
      }).catch(err => {
        toastr["error"](err);
      });
    },
    async load() {
      this.reglaCobro = await Axios.get(`/reglas-de-cobro/${this.reglaCobroId}`).then(resp => resp.data);
      this.aplica = this.reglaCobro.programa_id ? 'programa' : 'nacademico';
      await this.changeInstitucion();
    }
  },
  watch: {
    async multiwatch() {
      this.fechas_de_vigencia = await Axios.get(`/fechas-de-vigencia/filtrar?institucion_id=${this.reglaCobro.institucion_id}&ciclo_escolar_id=${this.reglaCobro.ciclo_escolar_id}&combo_select=si`).then(resp => resp.data);
    }
  }
}
</script>

<style>

</style>
